export const CONSTANTS = {
  SCREEN_GROUP: 'carrier',
  LIST_ALL: 'list-carrier-all',
  LIST_DELIVERY_SERVICE_CODE: 'list-carrier-delivery-service-code',
  GRID_CARRIER_LOOKUP_DIALOG: 'grid-carrier-lookup-dialog',
} as const;
